import React, { FC } from 'react'
import { Heading, Container } from '@components/gassan-ui'
import { Footer, Header, Page, PageTransition } from '@components/Page'
import { useLocalization } from '@components/Localization'
import WishlistList from '@components/_wishlist/WishlistList'
import { rem } from 'polished'

type Props = {}

const Wishlist: FC<Props> = () => {
  const { lang } = useLocalization()
  return (
    <Page slug="wishlist">
      <Header initialVariant="absolute" />
      <PageTransition>
        <Container maxWidth={rem(1450)}>
          <Heading
            variant="h2"
            as="h1"
            mt={{ _: '2.5rem', small: '3rem', large: '6rem' }}
            mb={{ _: '1.5rem', small: '2.5rem', large: '2rem' }}
          >
            {lang === 'nl' ? 'Uw wishlist' : 'Your wishlist'}
          </Heading>
          <WishlistList />
        </Container>
        <Footer />
      </PageTransition>
    </Page>
  )
}

export default Wishlist
